(function () {
  if (window.__lgProductVariantDropdownRestore) return;
  window.__lgProductVariantDropdownRestore = true;

  var styleId = 'lg-product-variant-dropdown-restore-style';
  var activeDropdown = null;
  var activeTrigger = null;
  var lastTouchAt = 0;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchStartTrigger = null;
  var touchMoved = false;
  var MOVE_THRESHOLD = 10;

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      'html body.template-product .t4s-product-form__variants,html body.template-product .t4s-product-form__variants .t4s-swatch,html body.template-product .t4s-product-form__variants .t4s-swatch__option,html body.template-product .t4s-product-form__variants .t4s-swatch__list{overflow:visible!important}',
      'html body.template-product .t4s-product-form__variants [data-dropdown-open]{pointer-events:auto!important;touch-action:pan-y!important}',
      'html body.template-product .t4s-dropdown__wrapper.is--opened{visibility:visible!important;opacity:1!important;pointer-events:auto!important;z-index:2147483647!important}',
      'html body.template-product .t4s-dropdown__wrapper.is--opened .t4s-dropdown__content,html body.template-product .t4s-dropdown__wrapper.is--opened [data-swatch-item]{pointer-events:auto!important}',
      '@media(min-width:768px){html body.template-product .t4s-product-form__variants .t4s-dropdown__wrapper.is--opened{display:block!important}}',
      '@media(max-width:767px){',
      'html body.template-product .t4s-dropdown__wrapper.lg-variant-dropdown-portal{position:fixed!important;top:auto!important;right:0!important;bottom:0!important;left:0!important;width:100vw!important;max-width:100vw!important;max-height:80vh!important;z-index:2147483647!important;transform:translateY(0)!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;display:block!important;background:#fff!important}',
      'html body.template-product .t4s-dropdown__wrapper.lg-variant-dropdown-portal .t4s-dropdown__content{max-height:calc(80vh - 46px)!important;overflow:auto!important;-webkit-overflow-scrolling:touch!important;background:#fff!important}',
      'html body.template-product .t4s-dropdown__wrapper.lg-variant-dropdown-portal [data-swatch-item],html body.template-product .t4s-dropdown__wrapper.lg-variant-dropdown-portal a,html body.template-product .t4s-dropdown__wrapper.lg-variant-dropdown-portal button{pointer-events:auto!important}',
      'html body.template-product .t4s-close-overlay.is--visible.is--pindop{pointer-events:none!important}',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function isProductDropdownTrigger(node) {
    return !!(node && node.closest('.template-product .t4s-product-form__variants') && node.matches('[data-dropdown-open]'));
  }

  function getDropdown(trigger) {
    var id = trigger && trigger.getAttribute('data-id');
    return id ? document.getElementById(id) : null;
  }

  function rememberOriginalPosition(dropdown) {
    if (!dropdown || dropdown.__lgVariantPlaceholder || !dropdown.parentNode) return;
    dropdown.__lgVariantPlaceholder = document.createComment('lg-variant-dropdown-placeholder');
    dropdown.parentNode.insertBefore(dropdown.__lgVariantPlaceholder, dropdown);
  }

  function restoreDropdown(dropdown) {
    if (!dropdown) return;
    if (dropdown.__lgVariantPlaceholder && dropdown.__lgVariantPlaceholder.parentNode) {
      dropdown.__lgVariantPlaceholder.parentNode.insertBefore(dropdown, dropdown.__lgVariantPlaceholder);
    }
    dropdown.classList.remove('lg-variant-dropdown-portal');
    dropdown.style.top = '';
    dropdown.style.right = '';
    dropdown.style.bottom = '';
    dropdown.style.left = '';
    dropdown.style.width = '';
    dropdown.style.maxWidth = '';
    dropdown.style.maxHeight = '';
    dropdown.style.zIndex = '';
  }

  function openDesktopDropdown(trigger, dropdown) {
    window.setTimeout(function () {
      if (!isProductPage() || isMobile() || !dropdown) return;
      document.querySelectorAll('.template-product .t4s-dropdown__wrapper.is--opened').forEach(function (item) {
        if (item !== dropdown) item.classList.remove('is--opened');
      });
      document.querySelectorAll('.template-product [data-dropdown-open].is--clicked').forEach(function (item) {
        if (item !== trigger) item.classList.remove('is--clicked');
      });
      dropdown.classList.add('is--opened');
      if (trigger) trigger.classList.add('is--clicked');
      activeDropdown = dropdown;
      activeTrigger = trigger;
    }, 0);
  }

  function openMobileDropdown(trigger, dropdown) {
    if (!isProductPage() || !isMobile() || !dropdown || !dropdown.classList.contains('t4s-dropdown__wrapper')) return;
    rememberOriginalPosition(dropdown);
    document.querySelectorAll('.template-product .t4s-dropdown__wrapper.is--opened').forEach(function (item) {
      if (item !== dropdown) item.classList.remove('is--opened');
    });
    document.querySelectorAll('.template-product [data-dropdown-open].is--clicked').forEach(function (item) {
      if (item !== trigger) item.classList.remove('is--clicked');
    });
    if (dropdown.parentNode !== document.body) document.body.appendChild(dropdown);
    dropdown.classList.add('lg-variant-dropdown-portal', 'is--opened');
    dropdown.style.top = 'auto';
    dropdown.style.left = '0';
    dropdown.style.right = '0';
    dropdown.style.bottom = '0';
    dropdown.style.width = '100vw';
    dropdown.style.maxWidth = '100vw';
    dropdown.style.maxHeight = '80vh';
    dropdown.style.zIndex = '2147483647';
    if (trigger) trigger.classList.add('is--clicked');
    activeDropdown = dropdown;
    activeTrigger = trigger;
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;
    dropdown.classList.remove('is--opened');
    restoreDropdown(dropdown);
    if (activeTrigger) activeTrigger.classList.remove('is--clicked');
    if (activeDropdown === dropdown) activeDropdown = null;
    activeTrigger = null;
  }

  function replayVariantChoice(item, dropdown) {
    restoreDropdown(dropdown);
    window.setTimeout(function () {
      if (window.jQuery_T4NT) window.jQuery_T4NT(item).trigger('click');
      else item.click();
      window.setTimeout(function () { closeDropdown(dropdown); }, 80);
    }, 0);
  }

  function getTouchPoint(event) {
    var touch = event.changedTouches && event.changedTouches[0] || event.touches && event.touches[0];
    return touch ? { x: touch.clientX, y: touch.clientY } : { x: 0, y: 0 };
  }

  function handleTouchStart(event) {
    if (!isProductPage() || !isMobile()) return;
    var trigger = event.target.closest && event.target.closest('[data-dropdown-open]');
    if (!isProductDropdownTrigger(trigger)) return;
    var point = getTouchPoint(event);
    touchStartX = point.x;
    touchStartY = point.y;
    touchStartTrigger = trigger;
    touchMoved = false;
  }

  function handleTouchMove(event) {
    if (!touchStartTrigger) return;
    var point = getTouchPoint(event);
    if (Math.abs(point.x - touchStartX) > MOVE_THRESHOLD || Math.abs(point.y - touchStartY) > MOVE_THRESHOLD) {
      touchMoved = true;
    }
  }

  function handleEvent(event) {
    if (!isProductPage()) return;
    ensureStyle();

    var portalItem = event.target.closest && event.target.closest('.lg-variant-dropdown-portal [data-swatch-item], .lg-variant-dropdown-portal .t4s-swatch__item');
    if (portalItem) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      replayVariantChoice(portalItem, portalItem.closest('.t4s-dropdown__wrapper'));
      return;
    }

    var trigger = event.target.closest && event.target.closest('[data-dropdown-open]');
    if (!isProductDropdownTrigger(trigger)) {
      if (event.type === 'click' && activeDropdown && !event.target.closest('.t4s-dropdown__wrapper')) closeDropdown(activeDropdown);
      return;
    }

    var dropdown = getDropdown(trigger);
    if (!dropdown) return;

    if (isMobile()) {
      if (event.type === 'touchend') {
        if (trigger !== touchStartTrigger || touchMoved) {
          touchStartTrigger = null;
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        lastTouchAt = Date.now();
        touchStartTrigger = null;
        openMobileDropdown(trigger, dropdown);
        return;
      }
      if (event.type === 'click') {
        if (Date.now() - lastTouchAt < 700) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        openMobileDropdown(trigger, dropdown);
      }
    } else if (event.type === 'click') {
      openDesktopDropdown(trigger, dropdown);
    }
  }

  function init() {
    if (!isProductPage()) return;
    ensureStyle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('touchstart', handleTouchStart, true);
  document.addEventListener('touchmove', handleTouchMove, true);
  document.addEventListener('touchend', handleEvent, true);
  document.addEventListener('click', handleEvent, true);
})();
